import React, { useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

export default function PrivateRoute() {
  const { user, loading, recovering, refreshUser } = useAuth()
  const hasToken = typeof window !== 'undefined' && !!localStorage.getItem('token')

  useEffect(() => {
    if (!loading && hasToken && !user) {
      refreshUser()
    }
  }, [loading, hasToken, user, refreshUser])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    )
  }

  if (user) {
    return <Outlet />
  }

  if (hasToken) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="text-center max-w-sm">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-500 mx-auto mb-4" />
          <p className="text-gray-700 font-medium">
            {recovering ? '正在恢复登录状态…' : '连接暂时中断，正在重试…'}
          </p>
          <p className="text-sm text-gray-500 mt-2 mb-4">
            您的登录凭证仍然有效，请稍候或点击下方重试。
          </p>
          <button
            type="button"
            className="px-4 py-2 rounded-lg bg-primary-600 text-white text-sm font-medium hover:bg-primary-700"
            onClick={() => refreshUser()}
          >
            重试
          </button>
        </div>
      </div>
    )
  }

  return <Navigate to="/login" replace />
}
